import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { useActiveColorScheme } from "@m/alchemy-theme";
import * as Styled from "./Tab.styled";
export const Tab = forwardRef((props, ref) => {
    /* istanbul ignore next */
    const { children, disabled, onClick, isActive, icon, palette = "interactiveConstructive", value, label, layout = "distributed", href, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, "aria-describedby": ariaDescribedBy, "aria-controls": ariaControls, "aria-haspopup": ariaHasPopup, "aria-expanded": ariaExpanded, ...otherProps } = props;
    const activeColorScheme = useActiveColorScheme();
    return (_jsx(Styled.Tab, { ref: ref, "data-testid": "Tab", flexGrow: layout.includes("distributed") ? 1 : 0, ...otherProps, children: _jsx(Styled.TabInner, { "aria-selected": isActive ? "true" : "false", as: href ? "a" : "button", activeColorScheme: activeColorScheme, href: href, "aria-disabled": disabled, isActive: Boolean(isActive), layout: layout, onClick: (e) => {
                if (disabled) {
                    // prevent navigation for link tabs and form buttons
                    e.preventDefault();
                    return;
                }
                onClick?.(e, props);
            }, onKeyDown: (e) => {
                if ((e.key === "Enter" || e.key === " ") && disabled) {
                    e.preventDefault();
                }
            }, palette: palette, role: "tab", "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, "aria-describedby": ariaDescribedBy, "aria-controls": ariaControls, "aria-haspopup": ariaHasPopup, "aria-expanded": ariaExpanded, value: value, children: _jsxs(Styled.TabContent, { children: [icon && icon, label && _jsx("span", { children: label }), children] }) }) }));
});
Tab.displayName = "Tab";
Tab.defaultProps = {
    onClick: () => { },
    layout: "distributed"
};
